import React, { useEffect, useState } from "react";
import * as S from "./styles";
import AddressIcon from "assets/category-icon.svg";
import { IAttachment } from "interfaces/Attachments";
import Geocoder from "react-geocode";

import { useReport } from "contexts/ReportContext";

export function VehicleReportModal() {
  const { report } = useReport();
  const [pr, setPr] = useState("0");
  const [rec, setRec] = useState("0");
  const [lastLocations, setLastLocations] = useState<string>();
  const [vehiclePics, setVehiclePics] = useState<IAttachment[]>([]);
  const [notFoundPics, setNotFoundPics] = useState<IAttachment[]>([]);
  const LOADSCRIPT_KEY = "AIzaSyCyYIwYpE42g7zN-nVRrPKkAwRseyccpaM";

  useEffect(() => {
    if (report?.occurrence.lastCoords) {
      Geocoder.setApiKey(LOADSCRIPT_KEY);
      Geocoder.setLanguage("br");
      Geocoder.fromLatLng(
        String(report?.occurrence.lastCoords[0][0]),
        String(report?.occurrence.lastCoords[0][1])
      ).then(
        (response) => {
          const address = response.results[0].formatted_address;
          setLastLocations(address);
        },
        (error) => {
          console.error(error);
        }
      );
    }
    let vehicleList: IAttachment[] = [];
    let notFoundList: IAttachment[] = [];

    report?.attachments.forEach((att: IAttachment) => {
      switch (att.category) {
        case "vehicle":
          vehicleList.push(att);
          break;

        case "notFound":
          notFoundList.push(att);
          break;
        default:
          break;
      }
    });
    setVehiclePics(vehicleList);
    setNotFoundPics(notFoundList);
  }, []);

  return (
    <div>
      <S.MoreDetailsContent>
        <S.ReportContent haveEmptyPictures={notFoundPics.length === 0}>
          <S.VehicleInformation>
            <S.InfoContainer>
              {vehiclePics.length === 0 && notFoundPics.length === 0 ? (
                <S.WaitingTitle>
                  Realizando procura do veículo...
                </S.WaitingTitle>
              ) : notFoundPics.length !== 0 ? (
                <S.NotFoundTitle>Veículo não encontrado</S.NotFoundTitle>
              ) : (
                <S.FoundTitle>Veículo encontrado</S.FoundTitle>
              )}

              <S.Information>
                <span>
                  <h4>Data de início</h4>
                  <p>
                    {report?.startTime
                      ? new Date(report?.startTime).toLocaleDateString(
                          "pt-BR",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "2-digit",
                          }
                        )
                      : "-"}
                  </p>
                </span>
                <span>
                  <h4>Deslocação</h4>
                  <p>
                    {report?.travelTime
                      ? new Date(report?.travelTime).toLocaleTimeString("pt-BR")
                      : "-"}
                  </p>
                </span>
                <span>
                  <h4>Valor recebido(REC)</h4>
                  <input
                    autoComplete="off"
                    defaultValue={report?.rec || "-"}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setRec(event.target.value);
                    }}
                  />
                </span>
                <span>
                  <h4>Data de finalização</h4>
                  <p>
                    {report?.endTime
                      ? new Date(report?.endTime).toLocaleDateString("pt-BR", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "2-digit",
                        })
                      : "-"}
                  </p>
                </span>
                <span>
                  <h4>Tempo adicional</h4>
                  <p>
                    {report?.additionalTime
                      ? new Date(report?.additionalTime).toLocaleTimeString(
                          "pt-BR"
                        )
                      : "-"}
                  </p>
                </span>
                <span>
                  <h4>Valor a pagar ao PR</h4>
                  <input
                    autoComplete="off"
                    defaultValue={report?.pr?.toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                    })}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setPr(event.target.value);
                    }}
                  />
                </span>
                <span>
                  <h4>Tipo</h4>
                  <p>{report?.type === 1 ? "Estabelecimento" : "Veículo"}</p>
                </span>
                <span>
                  <h4>Tempo total</h4>
                  <p>
                    {report?.totalTime
                      ? new Date(report?.totalTime).toLocaleTimeString("pt-BR")
                      : "-"}
                  </p>
                </span>
                <span>
                  <h4>Serviço</h4>
                  <p>-</p>
                </span>
              </S.Information>
              <S.AddressInfo>
                <h3>
                  <img src={AddressIcon} alt="img" /> Endereço{" "}
                </h3>
                <h4>Endereço de origem</h4>
                <p>
                  {
                    report?.occurrence.occurrencesSuperficialAddresses
                      .superficialAddress.street
                  }
                  ,{" "}
                  {
                    report?.occurrence.occurrencesSuperficialAddresses
                      .superficialAddress.number
                  }
                  -{" "}
                  {
                    report?.occurrence.occurrencesSuperficialAddresses
                      .superficialAddress.city
                  }{" "}
                  -{" "}
                  {
                    report?.occurrence.occurrencesSuperficialAddresses
                      .superficialAddress.uf
                  }
                </p>
                <h4>Última vez visto em</h4>
                <p>{lastLocations || "-"}</p>
              </S.AddressInfo>
            </S.InfoContainer>
          </S.VehicleInformation>
        </S.ReportContent>
      </S.MoreDetailsContent>
    </div>
  );
}
